import { Language as LanguageIcon } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
    Box,
    FormControl,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import { Theme } from "@mui/system";
import React from "react";
import { useTranslation } from "react-i18next";

interface LanguageSelectorProps {
    isMobile: boolean;
}

const LanguageSelector = (props: LanguageSelectorProps) => {
    const { isMobile } = props;
    const { i18n } = useTranslation();

    const changeLanguage = (event: SelectChangeEvent) => {
        // console.log(i18n.language);
        const selectedLanguage = event.target.value;
        i18n.changeLanguage(selectedLanguage);
        localStorage.setItem("language", selectedLanguage);
    };

    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                mr: 2,
            }}
        >
            <Box
                component={LanguageIcon}
                sx={{
                    display: { xs: "none", sm: "block" },
                }}
            />
            <Box
                component={FormControl}
                sx={{
                    margin: (theme: Theme) => theme.spacing(1),
                    minWidth: { xs: "70px", l: "120px" },
                }}
            >
                <Select
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    value={i18n.language}
                    onChange={changeLanguage}
                    sx={{
                        height: "35px",
                        color: isMobile ? "#FFF" : "#000",
                        border: isMobile ? "1px solid #FFF" : "none",
                    }}
                    IconComponent={() => (
                        <KeyboardArrowDownIcon
                            sx={{
                                color: isMobile ? "#FFF" : "#000", pr: "10px",
                                cursor: "pointer",
                            }}
                            onClick={handleOpen}
                        />
                    )}
                >
                    <MenuItem value="en">{isMobile ? "EN" : "English"}</MenuItem>
                    <MenuItem value="nl">{isMobile ? "NL" : "Nederlands"}</MenuItem>
                    <MenuItem value="fr">{isMobile ? "FR" : "Français"}</MenuItem>
                </Select>
            </Box>
        </Box>
    );
};

export default LanguageSelector;
